import { render, staticRenderFns } from "./LPjl.vue?vue&type=template&id=39c62724&scoped=true"
import script from "./LPjl.vue?vue&type=script&lang=js"
export * from "./LPjl.vue?vue&type=script&lang=js"
import style0 from "./LPjl.vue?vue&type=style&index=0&id=39c62724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c62724",
  null
  
)

export default component.exports